//#region IMPORT
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
/** Services Import */
/** Components */
import M_EIC_BASIC from './M_EIC_BASIC';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import useFcmHandler from '../../../Hooks/useFcmHandler';
import { useSearch2, useSearch3, useSave1 } from '../../EquipIssuance/M_EIC_BASIC/M_EIC_BASIC_Query';
import { useSave } from '../../../Hooks/useSave';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { M_EIC_BASIC_Schema } from './M_EIC_BASIC_Schema';
//#endregion

function M_EIC_BASICF() {
  //#region 변수
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.searchInfo);

  const depList = [{ value: '', name: '전체' }, ...searchInfo.depList];
  const depName =
    depList.find((d) => (d.value ?? '') === (searchInfo.depCd ?? ''))?.name ?? '전체';

  const dispatch = useDispatch();
  const [equipList, setEquipList] = useState([]); // 사업장별 보호구 리스트
  const [employeeList, setEmployeeList] = useState([]); // 근로자 리스트
  const [selectedEmployee, setSelectedEmployee] = useState(null); // 선택된 근로자
  const [selectedEquips, setSelectedEquips] = useState([]); // 선택된 보호구 리스트
  const [equipInputs, setEquipInputs] = useState({}); // 각 보호구별 입력값 (qty, reason, remark)
  const sendFcm = useFcmHandler();
  //#endregion

  //#region 나머지함수
  const Init = async () => {
    try {
      dispatch(NavBarInfoActions.setType('titleBar'));
      dispatch(NavBarInfoActions.setTitleName('보호구 지급'));

      await Search2Async({ custCd: userInfo.custCd ?? '' });
      await Search3Async({ custCd: userInfo.custCd ?? '' });
    } catch (e) {
      console.log('Error: ', e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: 'error',
        })
      );
    }
  };

  useEffect(() => {
    Init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!selectedEmployee) {
      setSelectedEquips([]);
      setEquipInputs({});
    }
  }, [selectedEmployee]);
  //#endregion

  //#region 쿼리
  const { runAsync: Search2Async } = useSearch2({
    onSuccess: (rows) => {
      setEmployeeList(rows);
    }
  });
  const { runAsync: Search3Async } = useSearch3({
    onSuccess: (rows) => {
      setEquipList(rows);
    }
  });
  const { runAsync: Save1Async } = useSave1();

  const { run: Save1 } = useSave({
    menuId: 'M_EIC_BASIC',
    schema: M_EIC_BASIC_Schema,
    saveData: () => (equipList
      .filter((equip) => {
        const equipId = equip.erCd;
        return equipId && selectedEquips.includes(equipId);
      })
      .map((equip) => {
        const equipId = equip.erCd;
        const inputs = equipInputs[equipId] || {};
        return {
          erCd: equip.erCd,
          equipNm: equip.equipNm,
          custCd: searchInfo.custCd,
          toUserId: selectedEmployee.id,
          qty: inputs.qty || '',
          reason: inputs.reason || '',
          remark: inputs.remark || '',
        };
      })),
    requestSave: (rows) => Save1Async(rows),
    onSuccess: () => {
      setSelectedEquips([]);
      setEquipInputs({});

      Search3Async({ custCd: userInfo.custCd ?? '' });

      sendFcm({
        targetUserId: selectedEmployee.id,
        requestUserId: userInfo.userid,
        body: `보호구가 지급되었습니다. 확인해주세요.`,
        status: '보호구지급',
        codeGroup: 'AL_008',
        title: '보호구 지급',
        route: '/M_EquipIssuanceStatus',
        responseData: '',
      });
    }
  });
  //#endregion

  //#region 이벤트 핸들러
  const HandleEmployeeSelect = (employee) => {
    setSelectedEmployee(employee);
  };

  const HandleEquipToggle = (equipId) => {
    if (!equipId || equipId === '') return;

    setSelectedEquips((prev) => {
      const index = prev.findIndex((id) => id === equipId);
      if (index >= 0) {
        // 선택 해제 시 입력값도 초기화
        setEquipInputs((prevInputs) => {
          const newInputs = { ...prevInputs };
          delete newInputs[equipId];
          return newInputs;
        });
        return prev.filter((id) => id !== equipId);
      } else {
        // 선택 시 기본값으로 초기화
        setEquipInputs((prevInputs) => ({
          ...prevInputs,
          [equipId]: {
            qty: '',
            reason: '',
            remark: '',
          },
        }));
        return [...prev, equipId];
      }
    });
  };

  const HandleInputChange = (equipId, field, value) => {
    setEquipInputs((prev) => ({
      ...prev,
      [equipId]: {
        ...prev[equipId],
        [field]: value,
      },
    }));
  };
  //#endregion

  return (
    <div className="wrap">
      <M_EIC_BASIC
        userInfo={userInfo}
        equipList={equipList}
        employeeList={employeeList}
        selectedEmployee={selectedEmployee}
        selectedEquips={selectedEquips}
        equipInputs={equipInputs}
        onEmployeeSelect={HandleEmployeeSelect}
        onEquipToggle={HandleEquipToggle}
        onInputChange={HandleInputChange}
        onSave={Save1}
        filterState={{
          depName: depName,
          depCd: searchInfo.depCd ?? '',
        }}
        depList={depList}
      />
    </div>
  );
}

export default M_EIC_BASICF;
